import FullWidthImageSlider from "../../../../src/components/FullWidthImageSlider";
import Slide from "../../../../src/components/FullWidthImageSlider/Slide";
import ImageReservationCheckout from "../../../../src/content/blog-posts/how-platform-fees-work/image1.png";
import * as React from 'react';
export default {
  FullWidthImageSlider,
  Slide,
  ImageReservationCheckout,
  React
};